export default __webpack_public_path__ + "static/media/call-center-banner.69477d9a.png";